import { SkiPassAgeLevels, Trip } from "@/types";
import { getTripById, updateTrip } from "./tripService";

/**
 * Service for managing ski pass age levels configuration.
 * Provides a dedicated interface for age levels operations while internally
 * using the trip service for persistence, maintaining modularity and separation of concerns.
 */
export const ageLevelsService = {
  /**
   * Updates the age levels configuration for a trip.
   * @param tripId The ID of the trip to update
   * @param ageLevels The new age levels configuration
   */
  updateAgeLevels: async (tripId: string, ageLevels: SkiPassAgeLevels): Promise<void> => {
    const trip = await getTripById(tripId);
    if (!trip) {
      throw new Error("Trip not found");
    }
    
    await updateTrip({ ...trip, skiPassAgeLevels: ageLevels });
  }
};